import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function fbConnectAccountClick() {
  pushClevertapEvent('FB Connect Account Click');
}

export function fbConnectAccountSuccess() {
  pushClevertapEvent('FB Connect Account Success');
}

export function fbConnectAccountFailure(failureReason) {
  pushClevertapEvent('FB Connect Account Failure', {
    'Failure Reason': failureReason,
  });
}

export function fbContinueSetupClick() {
  pushClevertapEvent('FB Continue Setup Click');
}

export function fbContinueSetupSuccess() {
  pushClevertapEvent('FB Continue Setup Success');
}

export function fbContinueSetupFailure(failureReason) {
  pushClevertapEvent('FB Continue Setup Failure', {
    'Failure Reason': failureReason,
  });
}

export function fbDisconnectClick() {
  pushClevertapEvent('FB Disconnect Click');
}

export function fbDisconnectSuccess() {
  pushClevertapEvent('FB Disconnect Success');
}

export function fbConnectAnotherOutletClick() {
  pushClevertapEvent('FB Connect Another Outlet Click');
}

export function fbConnectAnotherOutletSuccess() {
  pushClevertapEvent('FB Connect Another Outlet Success');
}

export function fbConnectAnotherOutletFailure(failureReason) {
  pushClevertapEvent('FB Connect Another Outlet Failure', {
    'Failure Reason': failureReason,
  });
}

export function fbUploadProductsClick() {
  pushClevertapEvent('FB Upload Products Click');
}

export function fbUploadProductsSuccess(numberOfProducts) {
  pushClevertapEvent('FB Upload Products Success', {
    'Number of Products': numberOfProducts,
  });
}
export function fbUploadProductsFailure(failureReason, numberOfProducts) {
  pushClevertapEvent('FB Upload Products Failure', {
    'Failure Reason': failureReason,
    'Number of Products': numberOfProducts,
  });
}

export function fbProductUploadExportClick() {
  pushClevertapEvent('FB Product Upload Export Click');
}

export function fbProductUploadExportSuccess() {
  pushClevertapEvent('FB Product Upload Export Success');
}

export function fbProductUploadExportFailure(failureReason) {
  pushClevertapEvent('FB Product Upload Export Failure', {
    'Failure Reason': failureReason,
  });
}
